var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnglishFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3.3C21.65 1.85 18.95 1 16 1V3.3H24Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.60078H26.8C25.95 4.75078 25 3.95078 24 3.30078H16V5.60078Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.69844H27.65C27.1 6.84844 26.5 6.09844 25.85 5.39844H15V7.69844Z",
    fill: "#ED4C5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.99922H28.85C28.5 9.19922 28.1 8.39922 27.65 7.69922H15V9.99922Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.3H29.6C29.4 11.5 29.15 10.75 28.85 10H15V12.3Z",
    fill: "#ED4C5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.6516H29.95C29.9 13.8516 29.75 13.1016 29.6 12.3516H15V14.6516Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.95 14.6484H15V15.7984H0C0 16.1984 -4.84288e-08 16.5484 0.05 16.9484H29.95C30 16.5484 30 16.1984 30 15.7984C30 15.3984 30 14.9984 29.95 14.6484Z",
    fill: "#ED4C5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.399805 19.2492H29.5998C29.7998 18.4992 29.8998 17.7492 29.9498 16.9492H0.0498047C0.0998047 17.6992 0.199805 18.4992 0.399805 19.2492Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1499 21.55H28.8499C29.1499 20.8 29.3999 20.05 29.5999 19.25H0.399902C0.599902 20.05 0.849902 20.8 1.1499 21.55Z",
    fill: "#ED4C5C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3499 23.8508H27.6499C28.0999 23.1008 28.4999 22.3508 28.8499 21.5508H1.1499C1.4999 22.3508 1.8999 23.1008 2.3499 23.8508Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1501 26.1516H25.8501C26.5001 25.4516 27.1501 24.6516 27.6501 23.8516H2.3501C2.8501 24.7016 3.5001 25.4516 4.1501 26.1516Z",
    fill: "#ED4C5C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9499 28.4484H23.0499C24.0999 27.7984 24.9999 26.9984 25.8499 26.1484H4.1499C4.9999 27.0484 5.9499 27.7984 6.9499 28.4484Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 30.7992C17.9502 30.7992 20.7002 29.9492 23.0502 28.4492H6.9502C9.3002 29.9492 12.0502 30.7992 15.0002 30.7992Z",
    fill: "#ED4C5C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.10078C5.95 3.75078 5 4.55078 4.15 5.40078C3.45 6.10078 2.85 6.90078 2.35 7.70078C1.9 8.45078 1.45 9.20078 1.15 10.0008C0.85 10.7508 0.6 11.5008 0.4 12.3008C0.2 13.0508 0.0999999 13.8008 0.05 14.6008C-4.84288e-08 15.0008 0 15.4008 0 15.8008H15V0.800781C12.05 0.800781 9.35 1.65078 7 3.10078Z",
    fill: "#428BC1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.5L12.75 2.25H13.5L12.9 2.75L13.1 3.5L12.5 3.05L11.9 3.5L12.1 2.75L11.5 2.25H12.25L12.5 1.5Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.30078L13.75 5.05078H14.5L13.9 5.55078L14.1 6.30078L13.5 5.85078L12.9 6.30078L13.1 5.55078L12.5 5.05078H13.25L13.5 4.30078Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.30078L9.75 5.05078H10.5L9.9 5.55078L10.1 6.30078L9.5 5.85078L8.9 6.30078L9.1 5.55078L8.5 5.05078H9.25L9.5 4.30078Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.30078L11.75 8.05078H12.5L11.9 8.55078L12.1 9.30078L11.5 8.85078L10.9 9.30078L11.1 8.55078L10.5 8.05078H11.25L11.5 7.30078Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.30078L7.75 8.05078H8.5L7.9 8.55078L8.1 9.30078L7.5 8.85078L6.9 9.30078L7.1 8.55078L6.5 8.05078H7.25L7.5 7.30078Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.30078L3.75 8.05078H4.5L3.9 8.55078L4.1 9.30078L3.5 8.85078L2.9 9.30078L3.1 8.55078L2.5 8.05078H3.25L3.5 7.30078Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.3008L13.75 11.0508H14.5L13.9 11.5508L14.1 12.3008L13.5 11.8508L12.9 12.3008L13.1 11.5508L12.5 11.0508H13.25L13.5 10.3008Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.3008L9.75 11.0508H10.5L9.9 11.5508L10.1 12.3008L9.5 11.8508L8.9 12.3008L9.1 11.5508L8.5 11.0508H9.25L9.5 10.3008Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.3008L5.75 11.0508H6.5L5.9 11.5508L6.1 12.3008L5.5 11.8508L4.9 12.3008L5.1 11.5508L4.5 11.0508H5.25L5.5 10.3008Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.3008L11.75 14.0508H12.5L11.9 14.5508L12.1 15.3008L11.5 14.8508L10.9 15.3008L11.1 14.5508L10.5 14.0508H11.25L11.5 13.3008Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.3008L7.75 14.0508H8.5L7.9 14.5508L8.1 15.3008L7.5 14.8508L6.9 15.3008L7.1 14.5508L6.5 14.0508H7.25L7.5 13.3008Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.3008L3.75 14.0508H4.5L3.9 14.5508L4.1 15.3008L3.5 14.8508L2.9 15.3008L3.1 14.5508L2.5 14.0508H3.25L3.5 13.3008Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90029 6.30078L5.50029 5.85078L6.10029 6.30078L5.85029 5.55078L6.45029 5.05078H5.70029L5.50029 4.30078L5.25029 5.05078H4.55029L5.15029 5.50078L4.90029 6.30078Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.900195 12.3008L1.5002 11.8508L2.1002 12.3008L1.8502 11.5508L2.4502 11.0508H1.7502L1.5002 10.3008L1.2502 11.0508H0.750195C0.750195 11.1008 0.700195 11.1508 0.700195 11.2008L1.1002 11.5008L0.900195 12.3008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishFlag);
export default __webpack_public_path__ + "static/media/englishFlag.0dda1e84e1dba373e689d3821ae12ef3.svg";
export { ForwardRef as ReactComponent };